import { render, staticRenderFns } from "./InstantOffers.vue?vue&type=template&id=1fff9e5a"
import script from "./InstantOffers.vue?vue&type=script&lang=js"
export * from "./InstantOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports